import { Box } from '@material-ui/core'
import { unwrapResult } from '@reduxjs/toolkit'
import GoBack from 'components/GoBack'
import FitContentPaper from 'components/Paper/FitContentPaper'
import { FormikHelpers } from 'formik'
import { useSnackbar } from 'notistack'
import React, { useEffect } from 'react'
import { RouteConfigComponentProps } from 'react-router-config'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { offeringListThunk, selectCurrentTempleOfferings } from 'store/reducers/temple/offeringSlice'
import {
    selectCurrentTempleStaffProfiles,
    selectStaffProfileStatus,
    staffProfileCreateThunk,
    staffProfileListThunk,
} from 'store/reducers/temple/staffProfileSlice'
import { selectAllUsers, usersListThunk } from 'store/reducers/temple/usersSlice'
import { StaffProfilePayloadType } from 'types/api/temple'
import { getFieldErrors } from 'utils/api'
import useRestricter from 'hooks/useRestricter'
import { PERMISSIONS, RESTRICTED_PATHS } from 'utils/permissions'
import FormStaffProfile from './FormStaffProfile'

type StaffProfileFormType = StaffProfilePayloadType & {
    languageText: string
}

const AddStaffProfile: React.FC<RouteConfigComponentProps> = props => {
    const dispatch = useAppDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const api = useAppSelector(selectStaffProfileStatus)
    const users = useAppSelector(selectAllUsers)
    const profiles = useAppSelector(selectCurrentTempleStaffProfiles)
    const offerings = useAppSelector(selectCurrentTempleOfferings)
    const hasAddPermission = useRestricter(PERMISSIONS.ADD, RESTRICTED_PATHS.STAFF_PROFILES)

    useEffect(() => {
        dispatch(usersListThunk())
        dispatch(staffProfileListThunk({}))
        dispatch(offeringListThunk({}))
    }, [dispatch])

    const handleSubmit = (data: StaffProfilePayloadType, actions: FormikHelpers<StaffProfileFormType>) => {
        dispatch(staffProfileCreateThunk(data))
            .then(unwrapResult)
            .then(response => {
                enqueueSnackbar(`${response.fullName} profile created`, { variant: 'success' })
                actions.resetForm()
            })
            .catch(err => {
                Object.entries(getFieldErrors(data, err)).forEach(([key, value]) => actions.setFieldError(key, value))
            })
            .finally(() => actions.setSubmitting(false))
    }

    if (!hasAddPermission) return null

    return (
        <GoBack {...props}>
            <FitContentPaper>
                <Box component='h4' mb={4}>Add Staff/Priest Profile</Box>
                <FormStaffProfile
                    users={users}
                    profiles={profiles}
                    offerings={offerings}
                    buttonLabel='Create'
                    api={api}
                    onSubmit={handleSubmit}
                />
            </FitContentPaper>
        </GoBack>
    )
}

export default AddStaffProfile
